export default __webpack_public_path__ + "static/media/worklist-icon.51a8a33b.svg";